<template>
  <v-card :outlined="resumeCardsOutlined">
    <v-card-title class="pb-0">
      <span class="headline">{{ $t('texts.myJobs') }}</span><br>
      <v-spacer/>
      <v-btn
        color="primary" light
        :small="$vuetify.breakpoint.smAndUp"
        :fab="$vuetify.breakpoint.xsOnly"
        :to="{ name: 'employee.resume.job' }"
        :disabled="!hasProfileCompleted"
      >
        <template v-if="$vuetify.breakpoint.smAndUp">{{ $t('texts.addExperience') }}</template>
        <v-icon
          color="white"
          :right="$vuetify.breakpoint.smAndUp"
        >
          add
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-0" v-html="$t('texts.myJobsIntro')"/>
    <v-progress-linear v-if="fetchResumePending" height="2" :indeterminate="true"/>
    <v-card-text v-else class="pa-0">
      <v-alert :value="!checkIfActualJob" color="warning" class="text-center">
        {{ $t('texts.attentionNoCurrentJob') }}
      </v-alert>
      <v-alert :value="!hasProfileCompleted" color="warning">
        {{ $t('texts.completeEmployeeProfile') }}
        <v-btn
          small outlined
          class="my-0"
          :to="{ name: 'employee.profile' }"
        >
          {{ $t('texts.completeProfile') }}
        </v-btn>
      </v-alert>
      <v-list three-line class="py-0">
        <template v-for="(item, index) in items">
          <resume-job-item
            :item="item"
            :key="`job-${index}`"
          />
          <v-divider
            v-if="index + 1 < items.length"
            :key="`job-divider-${index}`"
          />
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import ResumeJobItem from './ResumeJobItem.vue';

export default {
  name: 'EmployeeResumeJobs',
  components: {
    ResumeJobItem,
  },
  props: {
    fetchResumePending: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    resumeCardsOutlined: {
      type: Boolean,
      default: false,
    },
    hasProfileCompleted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkIfActualJob() {
      // TODO NEW -> Logic is shit
      if (this.items.length > 0) {
        const cutOffDateStart = moment().subtract(2, 'years');
        const cutOffDateEnd = moment().subtract(1, 'years');
        const latestJob = this.items[0];
        const startDate = moment([latestJob.start_year, latestJob.start_month - 1, 1]);
        const endDate = moment([latestJob.end_year, latestJob.end_month - 1, 1]);
        const differenceStart = startDate.diff(cutOffDateStart, 'days');
        const differenceEnd = endDate.diff(cutOffDateEnd, 'days');
        const actualJobIsSet = differenceStart > 0 || differenceEnd > 0;
        return actualJobIsSet;
      }
      return true;
    },
  },
};
</script>
